import React from "react";
import { Col, Row } from "react-bootstrap";

function ContactComponent() {
  return (
    <div>
      {/* Quotes */}

      <div className="quote-div">
        <h4>"The fondest memories are made when gathered around the table"</h4>
        <h6> - Ruhi Enterprise</h6>
      </div>
      {/* Contact */}
      <div className="contact">
        <Row>
          <Col className="map" xs={12} md={6}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3689.8686315561745!2d88.74622291543683!3d22.358588646425492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a021dbdc4215a01%3A0x67f95e0671b6f72d!2sRuhi%20Enterprise!5e0!3m2!1sen!2sin!4v1619018264196!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              className="map-g"
              title="map"
            ></iframe>
          </Col>
          <Col className="contact-details" xs={12} md={6}>
            <h1>Office Address</h1>
            <h5>Rabindrapalli, Suri-Dubrajpur Road, Near SBI Bank</h5>
            <h5>P.S : Suri, Pin : 731101</h5>
            <h5>Suri*Birbhum</h5>
            <h5>
              <span className="fa fa-mobile"></span> 8617626718
            </h5>
            <h5>
              <span
                className="fa fa-whatsapp"
                onClick={() => {
                  window.open("https://wa.me/919933315325");
                }}
              ></span>{" "}
              9933315325
            </h5>
            <h6>
              <span className="fa fa-envelope"></span>{" "}
              bapparuhienterprise@gmail.com
            </h6>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ContactComponent;
